/*
* QuotationsReducer
*/

import { fromJS, List } from 'immutable';
import {
  GET_QUOTATIONS,
  QUOTATIONS_RECEIVED,
  SEARCH_QUOTATIONS,
  FILTERS_RECEIVED,
  UPDATE_SORT,
  REMOVE_ALL,
  REMOVE_FILTER,
  SET_PAGE_NUMBER,
} from './constants';

import moment from 'moment';

const startOfMonth = moment().startOf('month').format('YYYY-MM-DD');
const endOfMonth   = moment().endOf('month').format('YYYY-MM-DD');

// The initial state of the App
export const initialState = fromJS({
  quotations: [],
  loading: false,
  parameters: {
    query: '',
    fiscal_code: '',
    quotation_id: '',
    startDate: startOfMonth,
    endDate: endOfMonth,
    status: [],
  },
  total: 0,
  lastPage: 0,
  itemsPerPage: 10,
  currentPage: 1,
  orders: new List(),
  filters: new List(),
  selectedOrder: 'date',
});

function quotationsReducer(state = initialState, action) {
  switch (action.type) {
    case GET_QUOTATIONS:
      return state.set('loading', true);
    case QUOTATIONS_RECEIVED:
      return state
        .set('quotations', action.quotations)
        .set('total', action.total)
        .set('lastPage', action.lastPage)
        .set('currentPage', action.currentPage)
        .set('loading', false);
    case SEARCH_QUOTATIONS:
      return state
        .set('parameters', fromJS(action.parameters))
        .set('currentPage', 1)
        .set('lastPage', 0)
        .set('loading', true);
    case FILTERS_RECEIVED:
      const { filters } = action;
      const { orders } = filters;
      delete filters.orders;
      return state.set('orders', new List(orders))
        .set('filters', filters);
    case UPDATE_SORT:
      return state
        .set('selectedOrder', action.order)
        .set('currentPage', 1)
        .set('lastPage', 0)
        .set('loading', true);
    case REMOVE_FILTER:
      return state
        .setIn(['parameters', action.filterName], '')
        .set('currentPage', 1)
        .set('lastPage', 0)
        .set('loading', true);
    case REMOVE_ALL:
      return state
        .set(
          'parameters',
          fromJS({
            query: '',
            fiscal_code: '',
            quotation_id: '',
          }),
        )
        .set('currentPage', 1)
        .set('lastPage', 0)
        .set('loading', true);
    case SET_PAGE_NUMBER:
      return state.set('currentPage', action.pageNumber);
    default:
      return state;
  }
}
export default quotationsReducer;
